<template>
    <div class="radio-group" role="radiogroup">
        <div v-for="option in options" :key="option.value" class="radio-group__option">
            <input
                :id="getOptionId(option)"
                :name="name"
                type="radio"
                class="radio-group__input"
                :value="option.value"
                :checked="value === option.value"
                :disabled="disabled || option.disabled"
                @change="onChange"
                @click="onClick"
            />
            <label class="radio-group__label" :for="getOptionId(option)">
                {{ option.label }}
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'inputRadioGroup',
    props: {
        value: {
            type: [String, Number, Boolean],
            default: null
        },
        options: {
            type: Array,
            required: true
        },
        name: {
            type: String,
            default: () => `radio-group-${Math.random().toString(36).substring(2, 15)}`
        },
        id: {
            type: String,
            default: () => `radio-group-${Math.random().toString(36).substring(2, 15)}`
        },
        withDeselect: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        getOptionId(option) {
            return option.id || `${this.id}-${option.value}`;
        },
        onChange(event) {
            const target = event.target
            const newValue = target.value
            this.$emit('change', newValue);
        },
        onClick(event) {
            const target = event.target
            const newValue = target.value
            if (this.withDeselect && this.value === newValue) {
                this.$emit('change', null);
                return;
            }
        }
    }
}
</script>

<style scoped>
.radio-group {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-sm);
}

.radio-group__option {
    display: flex;
    align-items: center;
    gap: var(--spacing-sm);
}

.radio-group__input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: grid;
    flex-shrink: 0;
    place-content: center;
    width: 14px;
    height: 14px;
    margin: 0;
    background-color: var(--background-white);
    border: 1px solid var(--color-primary);
    border-radius: 50%;
    cursor: pointer;
}

.radio-group__input::before {
    content: "";
    width: 10px;
    height: 10px;
    transform: scale(0);
    background-color: var(--color-primary);
    border-radius: 50%;
}

.radio-group__input:checked::before {
    transform: scale(1);
}

.radio-group__input:disabled {
    cursor: not-allowed;
    opacity: 0.5;
}

.radio-group__label {
    font-family: var(--font-family-primary);
    font-size: var(--text-xs);
    font-weight: 600;
    text-align: left;
    color: var(--color-secondary);
    cursor: pointer;
    user-select: none;
}

.radio-group__input:disabled + .radio-group__label {
    cursor: not-allowed;
    opacity: 0.5;
}
</style>
 